import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';

import RefData from 'ref-data';

import DisplayUnitCollection from './display-unit-collection';

function fetchDisplayUnits(params = {}) {
  return ajaxService
    .get('/api/xp/displayunit/list.json', {
      status: RefData.Enum.STATUS.DISPLAYUNIT.ACTIVE, // always only interested in active DU
      ...params,
    })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(DisplayUnitCollection.deserialize)
    .catch(error => ({ error }));
}

export default {
  fetchDisplayUnits,
};
